import axios from 'axios';

/**
 * Upload image to AWS S3 thru pre-assigned url
 * @param imageData uploaded image
 * @param entities pre-assigned url on AWS
 */
export async function putImageToS3(imageData: any, entities: any) {
  return axios.put(entities.url, { name: imageData });
}

/**
 * Upload a Blob object (e.g produced of
 * @param preSignedUrl
 * @param blob
 */
export async function putBlobToS3(
  preSignedUrl: string,
  blob: Blob,
): Promise<void> {
  const response = await fetch(preSignedUrl, {
    method: 'PUT',
    body: blob,
    headers: {
      'Content-Type': blob.type || 'application/octet-stream',
    },
  });

  if (!response.ok) {
    throw new Error(`Failed to upload file. HTTP status: ${response.status}`);
  }
}
